import { assertNever } from '@kofno/piper';
import { FilterOptionData } from '../Types';
import { action, makeObservable, observable } from 'mobx';
import {
  blank,
  closed,
  Filter,
  FilterOptions,
  opened,
  State,
  updatingSelectedOption,
} from './Types';

class FilterStore {
  @observable
  state: State;

  readonly initialFilterValues: Filter;

  constructor(filters: FilterOptionData[]) {
    makeObservable(this);
    // Start with no filters selected (empty array) to show all results by default
    // Users will then select filters to narrow down the results
    this.initialFilterValues = {
      options: [],
    };

    this.state = blank(this.initialFilterValues);
  }

  @action
  open = () => {
    switch (this.state.kind) {
      case 'closed':
        this.state = opened(this.state);
        break;
      case 'opened':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  close = () => {
    switch (this.state.kind) {
      case 'opened':
        this.state = closed(this.state);
        break;
      case 'closed':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  filterAllValues = (value: FilterOptions) => {
    switch (this.state.kind) {
      case 'opened':
        this.state = updatingSelectedOption(this.state, value, this.initialFilterValues.options);
        break;
      case 'closed':
        break;
      default:
        assertNever(this.state);
    }
  };
}

export default FilterStore;
